// @flow
import React, { useContext } from 'react';
import { compose } from 'redux';

import ReactAppContext from 'Context/ReactAppContext';
import { ProductsGrid } from 'Components/widgets/products-grid/ProductsGrid';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { COLORS } from 'Components/utils/color/colors';
import { getProductProps, setProductHref } from 'Components/widgets/product/Product.mapper';
import type { ThumbnailProduct } from 'Utils/resort-thumbnail-query/resortThumbnailQuery';
import { isSeller } from 'Utils/seller/sellerUtils';

type ProductRecommendationsLineProps = {
  config: {
    common: {
      close: string,
      thumbnailCTA: string,
      thumbnailTourCTA: string,
      recommendedResorts: string,
    },
    price: CMSPrice,
    resort: CMSResort,
  },
  recommendations?: {
    products: Array<ThumbnailProduct>,
  },
  resortId: string,
};

export const ProductRecommendationsLine = (props: ProductRecommendationsLineProps) => {
  const appContext = useContext(ReactAppContext);
  if (isSeller(appContext)) {
    return null;
  }

  const { config = {}, recommendations: { products } = { products: [] } } = props;
  const recommendedProducts = products.map(product =>
    compose(
      getProductProps,
      setProductHref,
    )({ config, product }),
  );
  const seeMore = {
    color: COLORS.GRAY,
    label: config.resort.moreResultsLabels.buttonLabel,
    text: config.resort.moreResultsLabels.label,
  };
  const title = config.common.recommendedResorts;
  return (
    <SiteContainer className="Line Line-ResortRecommendations">
      <ProductsGrid
        hasSeeMore
        isSynchronousGrid
        products={recommendedProducts}
        seeMore={seeMore}
        title={title}
      />
    </SiteContainer>
  );
};
